import { createAPI } from '@/request.js'
// 租赁订单
export const leaseList = data => createAPI('/api/order/lease/query.mt', 'post', data)
// 支付订单详情
export const payInfo = data => createAPI('/api/order/pay/query.mt', 'post', data)
// 收益详情
export const profitInfo = data => createAPI('/api/statement/lease/query.mt', 'post', data)
// 支付订单
export const payList = data => createAPI('/api/order/pay/query.mt', 'post', data)

export const rechargeRefund = data => createAPI('/api/order/recharge-refund.mt', 'post', data)
// 退款订单
export const refund = data => createAPI('/api/order/refund/query.mt', 'post', data)
// 完结订单
export const endOrder = data => createAPI('/api/order/lease/complete.mt', 'post', data)
// 取消订单
export const cancel = data => createAPI('/api/order/lease/cancel.mt', 'post', data)
// 回退金额
export const rollback = data => createAPI('/api/order/lease/refund.mt', 'post', data)
// 未完结预授权订单列表
export const authList = data => createAPI('/api/order/auth/query.mt', 'post', data)
// 完结预授权订单
export const endAuth = data => createAPI('/api/order/auth/deal.mt', 'post', data)
// 下载订单租借详情
export const excelOrder = data => createAPI('/download/leaseOrder/excel', 'get', data)
